<template>
    <b-row class="mt-3 mb-5">
      <b-col cols="auto" class="d-flex align-items-center mb-5 mb-lg-0">
        <span>Total de registros: {{ footer.totalItens }}</span>
      </b-col>
      <b-col cols="auto" class="d-flex align-items-center justify-content-end ml-auto">
        <b-pagination
          v-model="footer.paginaAtual"
          :total-rows="footer.totalItens"
          :per-page="footer.itensPorPagina"
          :disabled="tabelaEstaDesabilitada"
          aria-controls="tabela-listagem-cnpj"
          align="right"
        />
      </b-col>
    </b-row>
</template>

<script>
export default {
    name: "tabelaListagemCNPJFooter",
    props: {
        itensPorPagina: {
            type: Number,
            default: 5,
        },
        totalItens: {
            type: Number,
            required: true,
        },
        paginaAtual: {
            type: Number,
            default: 1,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            footer: {
                paginaAtual: 1,
                itensPorPagina: 5,
                totalItens: 0,
            },
            tabelaEstaDesabilitada: false,
        };
    },
    mounted() {
        this.footer.paginaAtual = this.paginaAtual;
        this.footer.itensPorPagina = this.itensPorPagina;
        this.footer.totalItens = this.totalItens;
    },
    watch: {
        'disabled': {
            immediate: true,
            handler(newVal) {
                this.tabelaEstaDesabilitada = newVal;
            },
        },
        itensPorPagina(newVal) {
            this.footer.itensPorPagina = newVal;
        },
        paginaAtual(newVal) {
            this.footer.paginaAtual = newVal;
        },
        totalItens(newVal) {
            this.footer.totalItens = newVal;
        },
        'footer.paginaAtual': function (newVal) {
            this.$emit('paginaAtualizada', newVal);
        },
    },
};
</script>